import * as React from 'react';
import { createSyncObservable } from '@avensia/excite';
import { getRequestContext } from '@avensia/excite/server/request-context';
import { getCookie } from 'hono/cookie';
import { setCustomerTypeOnCart } from './cart';

export type CompanyCustomerContext = {
  isCompanyCustomer: boolean;
  setCustomerType: (customerType: Excite.Commercetools.CustomerType) => void;
};

const IS_COMPANY_CUSTOMER_COOKIE_NAME = 'is_company_customer';

function getInititalState() {
  return __BROWSER__
    ? document.cookie.includes('is_company_customer')
      ? 'company'
      : 'private'
    : getCookie(getRequestContext().honoContext, IS_COMPANY_CUSTOMER_COOKIE_NAME) === 'true'
      ? 'company'
      : 'private';
}

export const [customerTypeObservable] = createSyncObservable<Excite.Commercetools.CustomerType | undefined>(undefined);

export function setCustomerType(customerType: Excite.Commercetools.CustomerType) {
  if (customerType === 'company') {
    document.cookie = `${IS_COMPANY_CUSTOMER_COOKIE_NAME}=true;path=/;max-age=${60 * 60 * 24 * 365}`;
  } else {
    document.cookie = IS_COMPANY_CUSTOMER_COOKIE_NAME + '=false;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT';
  }

  setCustomerTypeOnCart(customerType);
  customerTypeObservable.emit(customerType);
}

export function isCompanyCustomer(): boolean {
  return customerTypeObservable.currentSync() === 'company';
}

export function useCustomerType(): CompanyCustomerContext {
  const [, forceUpdate] = React.useReducer(x => x + 1, 0);
  if (customerTypeObservable.currentSync() === undefined) {
    customerTypeObservable.emit(getInititalState());
  }
  const isCompanyCustomer = customerTypeObservable.currentSync() === 'company';

  React.useEffect(() => {
    customerTypeObservable.on(() => forceUpdate());
  }, []);
  return { isCompanyCustomer, setCustomerType };
}
